import { Actions } from "../Actions/Actions";

const initialState = {
  isAuthenticated: false,
  token: "",
  user: {},
  selected: {}
};


export default function authenticationReducer(
  state = initialState,
  action
) {
  switch (action.type) {
    case Actions.LOGIN:
      return {
        ...state,
        isAuthenticated: true,
        user: action.data.user,
      };
    case Actions.SELECTED_USER:
      return {
        ...state,
        selected: action.data
      };
    case Actions.CLEAR_SELECTED:
      return {
        ...state,
        selected: {}
      };
    case Actions.LOGOUT:
      return {
        isAuthenticated: false,
        user: {},
      };
    default:
      return state;
  }
}
